import { render } from "./EditReclamationPage.vue?vue&type=template&id=46fb9206&ts=true"
import script from "./EditReclamationPage.vue?vue&type=script&lang=ts"
export * from "./EditReclamationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__